import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MEDAL_GALLERY } from "../config/siteImages";
import { useSiteImages } from "../hooks/useSiteImages";

const MedalPricingBanner = () => {
  const { getImage } = useSiteImages();
  return (
    <div className="relative bg-gradient-to-br from-[#0F2137] via-[#1a3a5c] to-[#0F2137] rounded-2xl overflow-hidden shadow-2xl">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>
      
      <div className="relative z-10 p-3 sm:p-5 md:p-12">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="text-xl sm:text-2xl md:text-5xl font-black text-white mb-2">
            HIGH-QUALITY <span className="text-[#D90429]">CUSTOM MEDALS</span>
          </h2>
          <p className="text-gray-300 text-sm sm:text-lg">By Lane4</p>
        </div>

        <div className="flex justify-center items-center gap-1 sm:gap-2 md:gap-4 mb-8 py-4">
          {MEDAL_GALLERY.map((medal, index) => (
            <motion.div
              key={medal.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex-shrink-0"
            >
              <img
                src={getImage(medal.key)}
                alt={medal.alt}
                style={{ objectPosition: getImage(`${medal.key}_pos`) || "center" }}
                className="w-14 h-14 sm:w-16 sm:h-16 md:w-28 md:h-28 rounded-full object-cover border-2 md:border-4 border-white/20 shadow-lg hover:scale-110 transition-transform duration-300"
              />
            </motion.div>
          ))}
        </div>

        <div className="grid grid-cols-3 gap-1.5 sm:gap-2 md:gap-4 mb-8 max-w-3xl mx-auto">
          <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} className="bg-[#D90429] rounded-xl p-2 sm:p-3 md:p-6 text-center shadow-lg min-w-0">
            <div className="text-xl sm:text-2xl md:text-5xl font-black text-white">$175</div>
            <div className="text-white/90 font-semibold uppercase tracking-wider text-[10px] sm:text-xs md:text-sm">Design</div>
          </motion.div>
          <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} transition={{ delay: 0.1 }} viewport={{ once: true }} className="bg-[#D90429] rounded-xl p-2 sm:p-3 md:p-6 text-center shadow-lg min-w-0">
            <div className="text-base sm:text-xl md:text-4xl font-black text-white whitespace-nowrap">$150-$280</div>
            <div className="text-white/90 font-semibold uppercase tracking-wider text-[10px] sm:text-xs md:text-sm">Mold</div>
            <div className="text-white/70 text-[10px] sm:text-xs mt-1">Starting at</div>
          </motion.div>
          <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} transition={{ delay: 0.2 }} viewport={{ once: true }} className="bg-[#D90429] rounded-xl p-2 sm:p-3 md:p-6 text-center shadow-lg min-w-0">
            <div className="text-xl sm:text-3xl md:text-5xl font-black text-white">300</div>
            <div className="text-white/90 font-semibold uppercase tracking-wider text-[10px] sm:text-xs md:text-sm">Min. Units</div>
          </motion.div>
        </div>

        <div className="text-center mb-8">
          <p className="text-xl md:text-2xl text-white/90 italic font-light">
            "We understand the importance of quality craftsmanship and attention to detail."
          </p>
        </div>

        <div className="text-center">
          <Link to="/contact" className="btn-primary inline-flex items-center gap-2 text-lg">
            Contact Us for Details <ArrowRight size={24} />
          </Link>
        </div>

        <div className="text-center mt-6">
          <p className="text-gray-400 text-sm">
            Production timeline: 45 days from design approval
          </p>
        </div>
      </div>
    </div>
  );
};

export default MedalPricingBanner;
